import React, { useContext } from 'react';

import AuthContext from 'common/auth';
import UiContext from 'common/UiContext/UiContext';
import classNames from 'classnames';
import Loading from 'components/Loading';

import './TwoFactorAuth.scss';

const TwoFactorAuth = () => {
  const { openModal } = useContext(UiContext);
  const { user } = useContext(AuthContext)!;
  const isLoading = false;

  return (
    <>
      <h3>Two-Factor Authentication</h3>
      <div
        className={classNames({
          box: true,
          isLoading,
        })}
      >
        {isLoading && <Loading />}
        {!user?.has_device
          ? <button className='primary big' onClick={() => openModal!('Otp')}>Set Up</button>
          : <>
            <button className='primary big' onClick={() => openModal!('OtpChallenge')}>Change Device</button>
            <button className='secondary big' onClick={() => openModal!('OtpRemove')}>Remove</button>
          </>
        }
      </div>
    </>
  );
};

export default TwoFactorAuth;